import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

const AdminRoute = ({ children, ...rest }) => {
  const { auth } = useSelector((state) => state);

  return (
    <Route
      {...rest}
      render={({ location }) => {
        return auth?.ok && auth?.user?.admin ? (
          React.cloneElement(children, { auth })
        ) : (
          <Redirect
            to={{
              pathname: '/',
            }}
          />
        );
      }}
    />
  );
};

export default AdminRoute;
